export default "__VITE_ASSET__WbIG84tG__"